import React from 'react';
import { Baby, ChevronRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import { formatDualPrice } from '../utils/priceUtils';

const KidsMenuHighlight = ({ onSelect }) => {
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const price = formatDualPrice(9.99);

  return (
    <div className="max-w-7xl mx-auto px-4 pt-5 sm:pt-6">
      <button
        type="button"
        onClick={onSelect}
        className={`w-full flex items-center gap-3 sm:gap-5 rounded-2xl border px-4 py-4 sm:px-6 sm:py-5 text-left cursor-pointer transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-[#C8102E]/70 focus-visible:ring-offset-2 focus-visible:ring-offset-background ${
          isDark
            ? 'bg-amber-400/10 border-amber-300/30 hover:bg-amber-400/15'
            : 'bg-amber-50 border-amber-200 hover:bg-amber-100/80 shadow-sm'
        }`}
        data-testid="kids-menu-highlight"
      >
        <span className="flex h-12 w-12 sm:h-14 sm:w-14 flex-shrink-0 items-center justify-center rounded-full bg-[#C8102E] text-white">
          <Baby size={26} aria-hidden="true" />
        </span>

        <span className="min-w-0 flex-1">
          <span className={`block font-cormorant text-xl sm:text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
            {t('kids_menu_title')}
          </span>
          <span className={`mt-0.5 block text-xs sm:text-sm ${isDark ? 'text-white/65' : 'text-gray-600'}`}>
            {t('kids_menu_short')}
          </span>
        </span>

        <span className="flex flex-shrink-0 items-center gap-2">
          <span className="text-right">
            <span className="block text-lg sm:text-2xl font-bold text-[#C8102E]">{price.eur} €</span>
            <span className={`block text-[10px] sm:text-xs ${isDark ? 'text-white/50' : 'text-gray-500'}`}>{price.bgn} {t('currency')}</span>
          </span>
          <ChevronRight className={isDark ? 'text-white/60' : 'text-gray-500'} size={22} aria-hidden="true" />
        </span>
      </button>
    </div>
  );
};

export default KidsMenuHighlight;

